import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyBHgHY21LC93YpOSVnNxhAzJpSC2MSOsyA",
  authDomain: "communitybridge-ai.firebaseapp.com",
  projectId: "communitybridge-ai",
  storageBucket: "communitybridge-ai.firebasestorage.app",
  messagingSenderId: "588423826384",
  appId: "1:588423826384:web:aefb96615035aaca0247d5"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export default app;
